<script setup>
import { useCasinoGamesStore } from "~/stores/casino-games";

const casinoGamesStore = useCasinoGamesStore();
</script>

<template>
    <div v-if="casinoGamesStore.games.length > 0" class="flex justify-center w-full mt-10">
        <div>
            <div class="h-0.5 w-44 bg-separator">
                <div :style="`width: ${casinoGamesStore.gameCountPercentage}%;`" class="h-full bg-brand-primary"></div>
            </div>
            <div class="text-center text-xs font-bold py-3">
                Mostrando {{ casinoGamesStore.state.showingItems }} de {{ casinoGamesStore.state.totalItems }}
            </div>
            <div class="flex justify-center">
            <button
            :disabled="casinoGamesStore.gameCountPercentage === 100"
            @click="casinoGamesStore.nextPage()"
            :class="{ 'opacity-50 cursor-not-allowed': casinoGamesStore.gameCountPercentage === 100 }"
            class="font-bold py-1 px-3 bg-brand-primary rounded-md"
        >
          Ver mais
        </button>              
            </div>
        </div>
    </div>
</template>